import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postCompaniesCompanyIdEmailSelfServeIpPoolCacheKeys } from "./constants";
import type {
  PostCompaniesCompanyIdEmailSelfServeIpPoolProps,
  PostCompaniesCompanyIdEmailSelfServeIpPoolResult,
  PostCompaniesCompanyIdEmailSelfServeIpPoolResultErrors,
} from "./types";

/**
 * POST handler for the "/companies/:company_id/email_self_serve/:app_group_id/ip_pool" endpoint
 */
export const postCompaniesCompanyIdEmailSelfServeIpPool = reactQueryMutationAdapter(
  postCompaniesCompanyIdEmailSelfServeIpPoolCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostCompaniesCompanyIdEmailSelfServeIpPoolResultErrors>()(
    ({
      companyId,
      appGroupId,
      name,
    }: PostCompaniesCompanyIdEmailSelfServeIpPoolProps): Promise<PostCompaniesCompanyIdEmailSelfServeIpPoolResult> => {
      return fetch(`/companies/${companyId}/email_self_serve/${appGroupId}/ip_pool`, "POST", { name }, undefined, {
        propagateFetchRequestError: false,
      });
    }
  )
);
